import {FeatureToggleConfigInterface} from "../interfaces";

export const FeatureToggleConfig: FeatureToggleConfigInterface = {
  integrationList: {
    tableColumns: [
      {
        header: "Title",
        width: "320px",
        field: "displayName",
        allowWrap: true
      },
      {
        header: "Description",
        width: "320px",
        field: "description"
      },
      {
        header: "Owner",
        width: "180px",
        field: "owner"
      },
      {
        header: "Info URL",
        width: "120px",
        field: "additionalInformation",
        isIcon: true
      },
      {
        header: "Rec. State",
        width: "120px",
        field: "recommendedState",
        transform: (value: unknown) => (value ? "On" : "Off")
      },
      {
        header: "Type",
        width: "120px",
        field: "type",
        transform: (value: unknown) => (value === "CustomerCountry" ? "Local" : (value as string))
      },
      {
        header: "Application",
        width: "150px",
        field: "application"
      },
      {
        header: "MYT CMS",
        width: "120px",
        field: "mytCms",
        isToggle: true
      },
      {
        header: "MYT LIVE",
        width: "120px",
        field: "mytLive",
        isToggle: true
      },
      {
        header: "MYT LIVE CHINA",
        width: "150px",
        field: "mytLiveChina",
        isToggle: true
      },
      {
        header: "",
        width: "60px",
        field: "actions",
        hasDetails: true,
        disableSort: true,
        isToggle: true
      }
    ]
  },
  stagingList: {
    tableColumns: [
      {
        header: "Title",
        width: "280px",
        field: "displayName",
        allowWrap: true
      },
      {
        header: "Description",
        width: "320px",
        field: "description"
      },
      {
        header: "Owner",
        width: "180px",
        field: "owner"
      },
      {
        header: "Info URL",
        width: "120px",
        field: "additionalInformation",
        isIcon: true
      },
      {
        header: "Rec. State",
        width: "120px",
        field: "recommendedState",
        transform: (value: unknown) => (value ? "On" : "Off")
      },
      {
        header: "Type",
        width: "120px",
        field: "type",
        transform: (value: unknown) => (value === "CustomerCountry" ? "Local" : (value as string))
      },
      {
        header: "Application",
        width: "150px",
        field: "application"
      },
      {
        header: "MYT CMS",
        width: "120px",
        field: "mytCms",
        isToggle: true
      },
      {
        header: "MYT LIVE",
        width: "120px",
        field: "mytLive",
        isToggle: true
      },
      {
        header: "MYT LIVE CHINA",
        width: "150px",
        field: "mytLiveChina",
        isToggle: true
      },
      {
        header: "",
        width: "60px",
        field: "actions",
        hasDetails: true,
        disableSort: true
      }
    ]
  },
  productionList: {
    tableColumns: [
      {
        header: "Title",
        width: "280px",
        field: "displayName",
        allowWrap: true
      },
      {
        header: "Description",
        width: "320px",
        field: "description"
      },
      {
        header: "Owner",
        width: "180px",
        field: "owner"
      },
      {
        header: "Info URL",
        width: "120px",
        field: "additionalInformation",
        isIcon: true
      },
      {
        header: "Rec. State",
        width: "120px",
        field: "recommendedState",
        transform: (value: unknown) => (value ? "On" : "Off")
      },
      {
        header: "Type",
        width: "120px",
        field: "type",
        transform: (value: unknown) => (value === "CustomerCountry" ? "Local" : (value as string))
      },
      {
        header: "Application",
        width: "150px",
        field: "application"
      },
      {
        header: "MYT CMS",
        width: "120px",
        field: "mytCms",
        isToggle: true
      },
      {
        header: "MYT LIVE",
        width: "120px",
        field: "mytLive",
        isToggle: true
      },
      {
        header: "MYT LIVE CHINA",
        width: "150px",
        field: "mytLiveChina",
        isToggle: true
      },
      {
        header: "",
        width: "60px",
        field: "actions",
        hasDetails: true,
        disableSort: true
      }
    ]
  }
};
